<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    let href = new URL(location.href)
    const params = new URLSearchParams(href.search);
    const token = params.get('token');
    const flag = params.get('flag');
    if(token){
      sessionStorage.setItem("tokenId", token);
      sessionStorage.setItem("userName", 'admin');
      sessionStorage.setItem("hadTip", false);
      sessionStorage.setItem("lastTime", new Date().getTime());
      if(flag=='1'){
      }        this.$router.push({ path: "/inspectionPlan" })

    }
  }
};
</script>

<style>
html,
body {
  height: 100vh;
  width: 100vw;
  margin: 0px 0px;
  padding: 0px 0px;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  height: 100vh;
  width: 100vw;
}
/* 使用自定义类名，只影响置信度popover，不影响其他地方 */
.confidence-popover {
  padding: 2px !important;
  background: transparent !important;
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue